import { MessagesSquare, Blocks, HeartHandshake } from "lucide-react";
import { Reveal, Chapter } from "@/components/Reveal";

const PILLARS = [
  {
    icon: MessagesSquare,
    color: "#7650c7",
    title: "Talk like humans",
    desc: "No jargon, no theatre. Plain English from the first call to the final handover — you will always know what is happening and why.",
  },
  {
    icon: Blocks,
    color: "#7abcb0",
    title: "Make the complex usable",
    desc: "Domains, hosting, DNS and the rest of the fog — handled for you and explained simply, so getting online never feels like a second job.",
  },
  {
    icon: HeartHandshake,
    color: "#f4d35e",
    title: "Leave things better than we found them",
    desc: "Careful craft and honest advice, even when the honest advice is that you need less than you thought.",
  },
];

export const Approach = () => (
  <section id="approach" data-testid="approach-section" className="px-5 py-24 sm:px-8 sm:py-32 lg:px-10">
    <div className="mx-auto max-w-7xl">
      <Chapter n="01" label="Our approach" />

      <div className="mt-10 grid gap-10 lg:grid-cols-12">
        <Reveal className="lg:col-span-6">
          <h2 className="font-display text-4xl font-bold leading-[0.98] tracking-[-0.04em] sm:text-6xl">
            Small studio.
            <br />
            <span className="text-[#7650c7]">Properly considered.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="flex items-end lg:col-span-6">
          <p className="max-w-[520px] text-base leading-relaxed text-[#6d687c] sm:text-lg">
            Getting online should feel like a useful next step, not a second job. We take the
            fog out of making a site — and leave you with something you are proud to send
            people to.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 grid gap-5 md:grid-cols-3">
        {PILLARS.map((p, i) => (
          <Reveal key={p.title} delay={0.1 + i * 0.12}>
            <div
              data-testid={`approach-pillar-${i + 1}`}
              className="group flex h-full flex-col rounded-[1.5rem] border border-[#201e32]/10 bg-white p-7 transition-[transform,border-color] duration-300 hover:-translate-y-1.5 hover:border-[#7650c7]/40 sm:p-8"
            >
              <span
                className="flex h-12 w-12 items-center justify-center rounded-full transition-transform duration-300 group-hover:scale-110"
                style={{ backgroundColor: p.color }}
              >
                <p.icon size={20} className="text-[#201e32]" aria-hidden />
              </span>
              <h3 className="mt-7 font-display text-2xl font-bold tracking-[-0.03em]">{p.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#6d687c]">{p.desc}</p>
              <span className="mt-auto pt-6 font-mono text-[10px] uppercase tracking-[0.22em] text-[#201e32]/40">
                0{i + 1} / the good stuff
              </span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
